<template>
  <div class="table-chips">
    <button
      v-for="table in tables"
      :key="table.id"
      type="button"
      :class="[statusClass(table), { active: isActive(table.id) }]"
      :disabled="table.isAvailable === false"
      @click="$emit('select', table.id)"
    >
      <span>{{ table.code }}</span>
    </button>
  </div>
</template>

<script>
import { getTableStatusClass } from '@/store/modules/tai-xiu';

/*
 * The Tài Xỉu table chip rail, shared by the mobile table bar and the desktop
 * pane so the two cannot drift apart -- the chips carry the arena palette the
 * PO signed off on (neutral pill, orange when active), which would otherwise
 * have to be duplicated.
 *
 * "Active" is passed in rather than derived, because the two callers disagree
 * on what active means: the mobile bar counts a quick-play table as active,
 * while a desktop pane only cares about the table it is showing.
 */
export default {
  name: 'TableChips',
  props: {
    tables: {
      type: Array,
      required: true,
    },
    // (tableId: string) => boolean
    isActive: {
      type: Function,
      default: () => false,
    },
  },
  methods: {
    statusClass: getTableStatusClass,
  },
};
</script>

<style lang="scss" scoped>
.table-chips {
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  button {
    flex: 0 0 auto;
    width: auto;
    height: 22px;
    min-height: 22px;
    padding: 0 10px;
    border: 1.5px solid rgba(190, 194, 214, 0.55);
    border-radius: 999px;
    background-color: rgba(3, 15, 24, 0.6);
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.03em;
    line-height: 1;
    cursor: pointer;
    box-sizing: border-box;

    span {
      display: block;
    }

    // Betting / result status, the cockfight arena rail's palette
    // (`bet-panel/arena-status-indicator.vue`): a coloured outline, filled
    // with that colour when active.
    &.green {
      --status-color: #0eb14d;
    }

    &.red {
      --status-color: #e85050;
    }

    &.blue {
      --status-color: #2890fa;
    }

    &.orange {
      --status-color: #ff8c38;
    }

    &.green,
    &.red,
    &.blue,
    &.orange {
      border-color: var(--status-color);
    }

    &.active {
      border-color: var(--status-color, #ff8c38);
      background: var(--status-color, #ff8c38);
      color: #fff;
    }

    &:disabled {
      opacity: 0.42;
      cursor: not-allowed;
    }
  }
}

@media screen and (max-width: 390px) {
  .table-chips {
    gap: 6px;

    button {
      padding: 0 8px;
    }
  }
}
</style>
